import { setupPhysicianSearch } from './physician-search/physician-search';

export * from './account-menu';
export * from './telephone';
export * from './simple-date';
export * from './overlay/overlay';
export * from './toast/toast';
export * from './forms/ajax';
export * from './tooltip/tooltip';
export * from './carousel/carousel';
export * from './popups/popup';
export * from './grow-network/grow-network';
export * from './physician-search/physician-search';

// Watchdog timer
document.addEventListener('DOMContentLoaded', () => {
    const isLoggedInInput = document.querySelector('#is-logged-in-input') as HTMLInputElement;
    const isLoggedIn = JSON.parse(isLoggedInInput.value);

    if (isLoggedIn)
    {
        // Check watchdog every 30 seconds
        setInterval(checkWatchdog, 30000);
    }
});

function checkWatchdog()
{
    fetch('/api/auth/watchdog')
        .then(response => response.json())
        .then((result: boolean) => {
            if (!result)
            {
                // If watchdog fails, navigate to homepage
                window.location.href = '/';
            }
        });
}

// Wire up physician search bar
document.addEventListener('DOMContentLoaded', () => {
    const headerPhysicianSearchBar = document.getElementById('header-physician-search');
    setupPhysicianSearch(headerPhysicianSearchBar as HTMLElement, null, onClickSelect, onClickMoreInfo);
});

function onClickSelect(searchBar: HTMLElement, resultsContainer: HTMLElement, link: HTMLElement)
{
    const physicianId = link.getAttribute('data-physician-id');
    const url = `/referral/new?referredToPhysicianId=${physicianId}`;
    location.href = url;
}

function onClickMoreInfo(searchBar: HTMLElement, resultsContainer: HTMLElement, link: HTMLElement)
{
    const href = link.getAttribute('data-profile-url');
    location.href = href;
}

// Always clear validation message on input
const allInputs = document.querySelectorAll('input, textarea, select') as NodeListOf<HTMLInputElement>;
for (const input of allInputs)
{
    input.addEventListener('input', event => {
        // Clear any lingering field validation issues
        input.setCustomValidity('');
    });
}

// Wire up footer video
window.addEventListener('load', () => {
    const footerVideo = document.querySelector('#footer-carousel video') as HTMLVideoElement;
    footerVideo.load();
    footerVideo.play().then();
});
